import { trigger, transition, animate, style, state } from '@angular/animations';

export enum AnimationState {
  None,
  FadeInFromBottom,
  OverviewHidden,
  OverviewVisible
}

export const mainContentAnimation = trigger('mainContentAnimationTrigger', [
  state(`${AnimationState.None}, void`, style({
      opacity: '0',
      top: '500px'
  })),
  state(`${AnimationState.FadeInFromBottom}`, style({
      opacity: '1',
      top: '0px'
  })),
  state(`${AnimationState.OverviewHidden}`, style({
    top: '-113px',
    height: '95%'
  })),
  state(`${AnimationState.OverviewVisible}`, style({
    top: '0',
    height: '83.4%'
  })),
  transition(`* => ${AnimationState.FadeInFromBottom}`, animate('0.5s 1s ease-in-out')),
  transition(`* => ${AnimationState.OverviewHidden}`, animate('0.2s 0s ease-in-out')),
  transition(`* => ${AnimationState.OverviewVisible}`, animate('0.2s 0s ease-in-out')),
]);

